export default function formatPhoneNumber(phoneNumber: string) {
  const s2 = ('' + phoneNumber).replace(/\D/g, '');
  if (s2.length > 10) {
    // dont format number if it has more than 10 characters
    return s2;
  }
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
}
